"use client";

import { PrimeReactProvider } from "primereact/api";

type PrimeReactProviderWrapperProps = {
  children: React.ReactNode;
};

export function PrimeReactProviderWrapper({
  children,
}: PrimeReactProviderWrapperProps) {
  return (
    <PrimeReactProvider
      value={{
        ripple: false,
        inputStyle: "filled",
        autoZIndex: true,
        hideOverlaysOnDocumentScrolling: false,
      }}
    >
      {children}
    </PrimeReactProvider>
  );
}
